module.exports = __webpack_public_path__ + "images/a53a64fdf7c03f6a1580203e723e4283b57e368d13bc4842f5457e942f732fc5.svg";